import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { useQuery } from '@apollo/client'
import { withRouter } from 'react-router'
import get from 'lodash/get'
import { GET_CONTENTS_AGGREGATIONS } from 'Queries'
import { Link } from 'Blocks'
import { path, getThemeFromQueryString, getUrlParameter } from 'Utils'
import config from 'Config'
import { PAGE_CONTEXT as p } from 'Constants'

const getContentQueryVariables = (size, type) => {
  const query = {
    arguments: {
      type,
      state: 'PUBLISHED'
    },
    pagination: {
      page: 1,
      size: size || config.pagination.articleList
    }
  }
  return query
}

function ContentFilter({
  clickHandler = () => {},
  type,
  location,
  pageName,
  className
}) {
  let filterName = 'themes'
  let argumentName = 'theme'
  if (pageName === p.INSTALOOK_LIST) {
    filterName = 'celebrities'
    argumentName = 'celebrity'
  }
  const allLinkClass = location.search === '' ? 'active' : ''
  const currentTheme = getThemeFromQueryString({ location })
  const currentCelebrity = getUrlParameter({ name: 'celebrity', location })
  const currentFilter = currentCelebrity || currentTheme

  const { data, loading, error } = useQuery(GET_CONTENTS_AGGREGATIONS, {
    variables: getContentQueryVariables(100, type),
    fetchPolicy: 'no-cache'
  })

  if (error) return null

  const filters = get(data, `contents.aggregations[${filterName}]`, [])
    .filter(filter => filter.name)
    .map(filter => filter.name)

  const LoadCustomGrid = () => {
    if(config.theme && config.theme === 'v1') {
      return (
        <div className="category-options-row text-lg-center">
          <Link
            onClick={clickHandler}
            className={`category-options-link ${allLinkClass}`}
            to={path(pageName)}
          >
            {config.locale === 'de' ? 'Alle' : 'All'}
          </Link>
          {filters.map((theme, index) => {
            const activeClass = theme === currentFilter ? 'active' : ''
            return (
              <Link
                onClick={clickHandler}
                to={path(
                  pageName,
                  {},
                  `?${argumentName}=${encodeURIComponent(theme)}`
                )}
                key={`content-filter-btn-${index}`}
                className={`category-options-link ${activeClass}`}
              >
                {theme}
              </Link>
            )
          })}
        </div>
      )
    } else {
      return (
        <div className={`content-filter ${className}`}>
          <div className="track">
            <Link
              onClick={clickHandler}
              className={`content-filter__button ${allLinkClass}`}
              to={path(pageName)}
            >
              {config.locale === 'de' ? 'Alle' : 'All'}
            </Link>

            {filters.map((theme, index) => {
              const activeClass = theme === currentFilter ? 'active' : ''
              return (
                <Link
                  onClick={clickHandler}
                  to={path(
                    pageName,
                    {},
                    `?${argumentName}=${encodeURIComponent(theme)}`
                  )}
                  key={`content-filter-btn-${index}`}
                  className={`content-filter__button ${activeClass}`}
                >
                  {theme}
                </Link>
              )
            })}
          </div>
        </div>
      )
    }
  }

  return filters.length > 0 ? (
    <LoadCustomGrid />
  ) : (
    <div className={`content-filter ${className}`}>
      <div className="loading-track"></div>
    </div>
  )
}

ContentFilter.propTypes = {
  className: PropTypes.any,
  clickHandler: PropTypes.func,
  location: PropTypes.shape({
    search: PropTypes.string
  }),
  pageName: PropTypes.any,
  type: PropTypes.any
}

// eslint-disable-next-line no-func-assign
ContentFilter = React.memo(ContentFilter)

export default withRouter(ContentFilter)
